var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row align-items-top container-box horizontal" },
    _vm._l(_vm.properties.slice(0, _vm.item_number), function(property) {
      return _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "row align-items-top" }, [
            _c("div", { staticClass: "col-5" }, [
              _c("a", {
                staticClass: "img",
                style:
                  "background-image: url('/storage/" +
                  property.images[0].path +
                  "');",
                attrs: {
                  href:
                    _vm.property_route.replace(
                      "slug",
                      property.translate.slug
                    ) + _vm.params,
                  target: "_blank",
                  alt: property.translate.name,
                  title: property.translate.name
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-7" }, [
              _c("div", { staticClass: "budget text-color-green" }, [
                _vm._v(_vm._s(_vm.__("pages.available")))
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      _vm.property_route.replace(
                        "slug",
                        property.translate.slug
                      ) + _vm.params,
                    target: "_blank"
                  }
                },
                [
                  _c(
                    "h4",
                    {
                      staticClass: "title",
                      attrs: { title: property.translate.name }
                    },
                    [_vm._v(_vm._s(property.translate.name))]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "address" }, [
                _vm._v(_vm._s(property.public_address))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "phone" }, [
                _vm._v(_vm._s(property.phone))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "price" }, [
                _c("span", [_vm._v(_vm._s(_vm.number_format(property.price)))]),
                _vm._v(_vm._s(" Ft" + _vm.__("pages.property.prices.from")))
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "star" }, [
                _c("i", { staticClass: "fas fa-star" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v("(" + _vm._s(property.rate_total) + ") "),
                  _c("small", [
                    _vm._v(
                      _vm._s(property.rate_count) +
                        " " +
                        _vm._s(_vm.__("pages.opinion"))
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }